import { PublicApiClient } from '@/services/PublicApiClient'
import { RetailerApiClient } from '@/services/RetailerApiClient.js'

import { APPLICATION_STATUSES } from '@/constants/constants'

export default {
  calculatePrice(salesChannelId, params) {
    return RetailerApiClient.post('sales-channel/' + salesChannelId + '/applications/calculate-prices', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createApplication(params) {
    return RetailerApiClient.post('sales-channel/' + params.sales_channel_id + '/applications/create', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  completeApplication(applicationId, params) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', {
      ...params,
      target_state: APPLICATION_STATUSES.COMPLETED
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  findeksConfirm(applicationId, params) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', {
      ...params,
      target_state: APPLICATION_STATUSES.FINDEKS_PIN_CONFIRMED
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateBirthdate(applicationId, params) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', {
      ...params,
      target_state: APPLICATION_STATUSES.FINDEKS_VALIDATED
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveSurveyAnswers(applicationId, params) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  pinConfirm(applicationId, params) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', {
      ...params,
      target_state: APPLICATION_STATUSES.FIBA_PIN_CONFIRMED
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  documentWaiting(applicationId) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', {
      target_state: APPLICATION_STATUSES.DOCUMENT_WAITING
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  rejectDocumentRequiredApplication(applicationId) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', {
      target_state: APPLICATION_STATUSES.REJECTED
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  confirmPaymentPlan(applicationId) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', {
      target_state: APPLICATION_STATUSES.FIBA_USED_PROCESS_WAITING
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startUsedProcess(applicationId, params) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', {
      ...params,
      target_state: APPLICATION_STATUSES.FIBA_DOCUMENTS_WAITING
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCountries() {
    return RetailerApiClient.get('countries')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  validateFibaApplicationHashAndGetFarmerFullname(hash) {
    return PublicApiClient.get('applications/' + hash + '/validate-and-get-farmer-fullname')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  confirmFibaApplication(fibaApplicationHash) {
    return PublicApiClient.post('applications/' + fibaApplicationHash + '/confirm')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  resendDocumentConfirmationLink(applicationId) {
    return RetailerApiClient.post('sales-channel/applications/' + applicationId + '/transition', {
      target_state: APPLICATION_STATUSES.FIBA_DOCUMENTS_CONFIRMATION_WAITING
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
